import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

export default function NewsListItem({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-accent-400 transition-colors cursor-pointer"
    >
      <div className="w-32 h-20 md:w-44 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 欲望之岛资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <span className="text-[11px] font-label text-accent-600">{item.category}</span>
        <h3 className="mt-1 text-sm md:text-base font-heading font-semibold text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-2 hidden sm:block">
          {item.summary}
        </p>
        <div className="mt-auto pt-2 flex items-center gap-3 text-[11px] text-foreground-500 font-label">
          <span>{item.date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {item.author}
          </span>
        </div>
      </div>
    </Link>
  );
}